import { Loader } from '@jutro/components';
import { ErrorBoundary } from '@xengage/gw-portals-error-react';
import { withViewModelService } from '@xengage/gw-portals-viewmodel-react';
import { Wizard } from '@xengage/gw-portals-wizard-react';
import { CodegenContext } from 'gw-capability-quoteandbind-PremierCT-react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { useWizardError, useWizardExit, useWizardInit } from './hooks';
import wizardStepToFieldMapping from './config/PremierCT-wizard-step-to-field-mapping.json5';

function PECodegenWizard(props) {
    const [hasErrorOccurred, setHasErrorOccurred] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const { location, match, history, viewModelService } = props;
    const pathParams = match.url.split('/');
    const productCode = pathParams[1];

    // hook to initialize the wizard
    const { submissionVM, wizardSteps, wizardTitle, presentationMetadata } =
        useWizardInit({
            productCode,
            location,
            history,
            viewModelService,
            setIsLoading,
        });
    const lobData = _.get(submissionVM, 'lobData.value');
    const firstAvailableLob = lobData && Object.keys(lobData)[0];
    const codegenContext = {
        presentationMetadata,
        lineName: firstAvailableLob,
        lobName: productCode,
        productCode: productCode,
    };

    // handles modals when exiting/cancelling the flow
    const handleCancel = useWizardExit({
        hasErrorOccurred,
        history,
        setIsLoading,
    });

    // handles error modals
    const handleError = useWizardError({ location, setHasErrorOccurred });

    if (isLoading) {
        return <Loader loaded={!isLoading} />;
    }

    if (!submissionVM) {
        return null;
    }

    return (
        <ErrorBoundary onError={handleError}>
            <CodegenContext.Provider value={codegenContext}>
                <Wizard
                    initialSteps={wizardSteps}
                    wizardTitle={wizardTitle}
                    initialData={submissionVM}
                    onCancel={handleCancel}
                    wizardStepToFieldMapping={wizardStepToFieldMapping}
                    skipCompletedSteps={false}
                />
            </CodegenContext.Provider>
        </ErrorBoundary>
    );
}

PECodegenWizard.propTypes = {
    viewModelService: PropTypes.shape({
        create: PropTypes.func,
    }).isRequired,
    history: PropTypes.shape({
        push: PropTypes.func,
    }).isRequired,
    location: PropTypes.shape({
        state: PropTypes.shape({
            quoteentry: PropTypes.shape({
                postalCode: PropTypes.string,
                quoteID: PropTypes.string,
            }),
        }),
    }).isRequired,
};

export default withRouter(withViewModelService(PECodegenWizard));
